import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getTitleByPath } from '../../constants/RoutesConstants';

// Agent configuration owns #module-title (back + agent name). Parent effects run after
// children, so ModuleTitleMC must not overwrite that title on this route.
const AGENT_CONFIG_PATH = /\/chatbot_ai\/agents\/[^/]+\/config\/?$/;

const ModuleTitleMC = () => {
  const location = useLocation();
  const { t } = useTranslation('Routes');

  useEffect(() => {
    if (AGENT_CONFIG_PATH.test(location.pathname)) return;

    const titleModule = document.getElementById('module-title');
    if (!titleModule) return;

    const newTitle = getTitleByPath(location.pathname);
    if (newTitle) {
      titleModule.innerText = t(newTitle);
    } else {
      titleModule.innerText = '';
    }
  }, [location.pathname, t]);

  return null;
};

export default ModuleTitleMC;
